// Module
var code = `<div class="progressBarContainer"> <div class="progressBar" ng-style="{width: \$ctrl.formattedProgress}"></div> <div class="progressBarLabel" ng-bind="\$ctrl.label || \$ctrl.formattedProgress">0%</div> </div> `;
// Exports
export default code;